/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSimilarItemsGridSeller_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGridSeller_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FavoritesProvider_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
